<template>
  <div class="overlay-container">
    <img
      class="papsi-mascot"
      src="https://resource.pafcpic.net/assets/pia/images/elements/papsi_kalabaw.png"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({})
</script>

<style scoped>
/* Equivalent of bg-black/80 + backdrop-blur-md + fixed inset-0 + flex center */
.overlay-container {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.8); /* same as bg-black/80 */
  backdrop-filter: blur(12px); /* same as backdrop-blur-md */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* Mascot animation */
@keyframes mascot-wave {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
}

.papsi-mascot {
  width: 40%;
  max-width: 250px;
  margin-bottom: 2.5rem;
  animation: mascot-wave 1s ease-in-out infinite;
  transform-origin: top center;
}

/* Optional background class from your earlier snippet */
.bg-translucent {
  background-color: rgba(77, 77, 77, 0.25);
}
</style>
